import handler from 'api/handler'

const prefix = '/admin/user'

const methods = {
  create: args => handler({ method: 'post', url: prefix + '/create', args, isFile: true }),
  fetchAll: args => handler({ method: 'get', url: prefix + '/fetchAll', args }),
  blockUser: args => handler({ method: 'put', url: prefix + '/blockUser', args }),
  updateApprovalStatus: args => handler({ method: 'put', url: prefix + '/updateApprovalStatus', args }),
  fetchNewlyCreated: args => handler({ method: 'get', url: prefix + '/fetchNewlyCreated', args }),
  changePin: args => handler({ method: 'put', url: prefix + '/changePin', args }),
  fetchSingle: args => handler({ method: 'get', url: prefix + '/fetchSingle/' + args.id, args }),
  fetchApprovalStatus: args => handler({ method: 'get', url: prefix + '/fetchApprovalStatus/' + args.id, args }),
  searchByCity: args => handler({ method: 'get', url: prefix + '/searchByCity', args }),
  searchByPhoneNo: args => handler({ method: 'get', url: prefix + '/searchByPhoneNo', args }),
  fetchPendingAadhaarVerifications: args => handler({ method: 'get', url: prefix + '/fetchPendingAadhaarVerifications', args }),
  updateAadhaarVerificationStatus: args => handler({ method: 'put', url: prefix + '/updateAadhaarVerificationStatus', args })
}

export default methods
